import React from "react"
import {styled} from "@mui/material/styles"
import Typography from "@mui/material/Typography"

interface HFClearAllProps {
    children: string
    childtestid: string
    clearAllFilters: () => void
}

export const StyledHFClearAll = styled(Typography)`
    color: ${({theme}) => theme.colours.palette.primary.main};
    cursor: pointer;
    font-weight: bold;
    margin-top: 0.8rem;
    font-family: ${({theme}) => `${theme.colours.components.buttonMedium.fontFamily}, ${theme.colours.font.default}`};
`
StyledHFClearAll.displayName = "StandardHFStyledClearAll"

export const HFClearAll = ({children, childtestid, clearAllFilters}: HFClearAllProps) => {
    return (
        <StyledHFClearAll data-testid={childtestid} onClick={clearAllFilters}>
            {children}
        </StyledHFClearAll>
    )
}

export default HFClearAll
